<template>
  <div class="sb-nav-fixed">
    <b-alert
      class="fixed-top"
      style="top: 56px; z-index: 10000000;"
      :show="alert.dismissCountDown"
      dismissible
      :variant="alert.variant"
      @dismissed="alert.dismissCountDown=0"
    >
      <p>{{ alert.text }}</p>
    </b-alert>
    <b-modal id="locationChooser" hide-footer centered title="Standortauswahl">
      <div role='button' class="h4 p-1 btn-link" v-for="(elem,idx) in getLocations"
           v-bind:key="'Location_' + idx"
           @click="changeLocation(elem)">{{ elem.sName }}
      </div>
    </b-modal>

    <div class="sb-topnav navbar navbar-expand navbar-light bg-light">

      <img @click="nav('/')" class="ml-3 mr-1 logo my-1 pointer" src="@/assets/lion.png"/>

      <button @click="toggleSideNav" class="btn btn-link btn-sm order-1 order-lg-0" id="sidebarToggle" href="#">
        <i class="fas fa-bars text-secondary"></i>
      </button>

      <b-navbar-nav class="ml-auto">
        <b-nav-item-dropdown right>
          <template #button-content>
            <i class="fas fa-user fa-2x fa-fw text-primary"></i>
          </template>

          <b-dropdown-item v-if="showEditProfile" @click="nav('/profile')"> Profil bearbeiten</b-dropdown-item>
          <b-dropdown-item v-if="showEditPassword" @click="nav('/password')"> Passwort ändern</b-dropdown-item>
          <b-dropdown-item v-if="countLocations>1" @click="showLocationChooser"> Standort wechseln</b-dropdown-item>

          <b-dropdown-item @click="nav('/login')">Logout</b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </div>
    <div id="main-content" v-bind:class="{ 'sb-sidenav-toggled': !sbHidden}">
      <div id="layoutSidenav">
        <SideMenu></SideMenu>

        <div @click="hideSideNav" id="layoutSidenav_content">
          <main class="">
            <div class="mt-2 mt-lg-3 container-fluid vld-parent content-container">
              <loading :active.sync="isLoading" :is-full-page="loadingFullscreen" :opacity=1 :z-index=1037
                       transition="none"></loading>

              <router-view @alert="showAlert" @nav="hideAlert">
                <!--:key="$route.fullPath">-->
              </router-view>
            </div>
          </main>

          <footer class="py-4 bg-light mt-auto">
            <div class="container-fluid">
              <div class="d-flex align-items-center justify-content-between small">
                <div class="text-muted">Copyright &copy; findSolutions GmbH {{ currYear }}</div>
                <div style="text-align: right;">
                  <router-link to="/datenschutz">Datenschutz</router-link>
                  &middot;
                  <router-link to="/impressum">Impressum</router-link>
                </div>
              </div>
            </div>
          </footer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SideMenu from '@/components/SideMenu'
import store from '../store'
import { dom, library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  components: {
    SideMenu,
    Loading
  },
  created () {
    var css = [
      '/static/datatables.min.css'
    ]

    css.forEach(c => {
      const tag = document.createElement('link')
      tag.setAttribute('href', c)
      tag.setAttribute('type', 'text/css')
      tag.setAttribute('rel', 'stylesheet')

      document.head.appendChild(tag)
    })
  },
  mounted () {
    library.add(fas)
    dom.watch()

    this.intervalInstance = setInterval(function () {
      store.dispatch('fetchToken', true).then(function (data) {
        console.log('token refreshed')
      })
    }, 60 * 45 * 1000) // 45 min
    this.sbHidden = !this.$screen.lg
  },
  beforeDestroy () {
    clearInterval(this.intervalInstance)
  },
  computed: {
    countLocations () {
      return this.$store.getters.getLocations.length
    },
    getLocations () {
      return this.$store.getters.getLocations
    },
    getLocationName () {
      return (this.$store.getters.getLocation !== undefined) ? this.$store.getters.getLocation.sName : ''
    },
    isLoading () {
      return this.$store.getters['menu/getLoading']
    }
  },
  data () {
    return {
      loadingFullscreen: !this.$screen.lg,
      intervalInstance: null,
      currYear: new Date().getFullYear(),
      sbHidden: false,
      showEditProfile: this.$store.getters.hasPermission(this.$module.IDENTIFIER_MYPROFILE, this.$permission.RECHT_Access_Own),
      showEditPassword: this.$store.getters.hasPermission(this.$module.IDENTIFIER_MYPASSWORD, this.$permission.RECHT_Access_Own),
      alert: {
        dismissCountDown: 0,
        variant: 'success',
        text: 'Die Änderungen wurden erfolgreich gespeichert.'
      }
    }
  },
  methods: {
    showLocationChooser () {
      this.$bvModal.show('locationChooser')
    },
    async changeLocation (location) {
      await this.$store.dispatch('changeLocation', { location: location })
      await this.$store.dispatch('menu/fetchMenu')

      this.showEditProfile = this.$store.getters.hasPermission(this.$module.IDENTIFIER_MYPROFILE, this.$permission.RECHT_Access_Own)
      this.showEditPassword = this.$store.getters.hasPermission(this.$module.IDENTIFIER_MYPASSWORD, this.$permission.RECHT_Access_Own)

      this.$bvModal.hide('locationChooser')
      this.$router.push('/')
    },
    nav (path) {
      this.$router.push(path)
    },
    toggleSideNav () {
      this.sbHidden = !this.sbHidden
    },
    hideSideNav () {
      if (!this.$screen.lg) {
        this.sbHidden = true
      }
    },
    showAlert (text, variant = 'success', dismissCountDown = 10) {
      this.alert.dismissCountDown = dismissCountDown
      this.alert.variant = variant
      this.alert.text = text
    },
    hideAlert () {
      this.alert.dismissCountDown = 0
    }
  },
  watch: {
    '$screen.width' () {
      this.loadingFullscreen = !this.$screen.lg
      this.sbHidden = !this.$screen.lg
    },
    '$route' () {
      this.hideAlert()
    }
  }
}
</script>

<style lang="scss">
.none-enter-active,
.none-leave-active {
  transition: opacity 0s ease;
}

.none-enter-from,
.none-leave-to {
  opacity: 0;
}
</style>
